import { render, staticRenderFns } from "./CandidateAnswerOutdatedComponent.vue?vue&type=template&id=49fe8a0e&"
import script from "./CandidateAnswerOutdatedComponent.vue?vue&type=script&lang=js&"
export * from "./CandidateAnswerOutdatedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports